import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'


export default {
    props: {
        index: Number,
        modelId: Object,
        modelObject: Object,
        actionLabel: String,
        actionTitle: String,
        editMode: Boolean,
        parentScreenParameters: Object
    },

    mixins: [],

    components: {
        
    },

    data: function () {
        return {
            screenKey: "UserImportModel",
            loading: false,
            actionLocked: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {
                
            },
            
            applicationResources: null,
            toolTipStates: {},
            
        }
    },

    computed: {
        screenTitle: function () {
            return 'Users';
        },

        
    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }
            
            return this.modelErrors[field];
        },

        formFiles: function () {
            let files = [];

            if (this.model.Files != null) {
                files.push(...this.model.Files);
            }

            return files;
        },

        emptyModel() {
            return {
                Files: [],

            }
        },

        
        
        onLoadFieldDataSources() {
            
        },

        async show() {
            if (this.modelObject && this.modelObject.Id > 0)
                {
                    // Edit
                    this.model = this.emptyModel();
                    this.model.Id = this.modelObject.Id;
                    this.$applyModelFields(this.modelObject, this.model);
                } else {
                    // Create
                    this.model = this.emptyModel();
                    this.$applyModelFields(this.modelObject, this.model);
                }

                this.onLoadFieldDataSources();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        async onDialogHide() {
            this.$emit('hide');
            
        },

        async onOkClick() {
            if(this.actionLocked)
                return;
            try {
                this.actionLocked = true;
                let validateResult = await this.$refs.modelForm.validate();
                if (validateResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: this.formFiles() });
                    this.hide();
                }
            }
            finally {
                this.actionLocked = false;
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}